import React, { useEffect, useState } from "react";
import loginpage from "assets/images/loginpage.svg";
import { Card, Col, Row } from "react-bootstrap";
import CustomSignup from "./CustomSignup";
import CustomLogin from "./CustomLogin";
import SignIn from "./SignIn";
import { login } from "ServerAPI/serverAPI";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import microsoftIcon from "../../assets/images/png/microsoft-icon.png";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import TokenBasedAuth from "./TokenBasedAuth";

const AuthHome = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSsoLogin, setShowSsoLogin] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [tokenFromUrl, setTokenFromUrl] = useState(null);
  const [processingToken, setProcessingToken] = useState(false);
  const navigate = useNavigate();

  const handleShowLogin = () => {
    setShowSsoLogin(false);
    setShowLogin((pre) => !pre);
  };

  const handleShowSsoLogin = () => {
    setShowSsoLogin((pre) => !pre);
  };

  const handleTokenAuthSuccess = (userData) => {
    console.log('Token authentication successful:', userData);
    setProcessingToken(false);
    // Navigation is handled by TokenBasedAuth component
    navigate("/dashboard/overview");
  };

  const handleTokenAuthFailure = (error) => {
    console.log('Token authentication failed:', error);
    setProcessingToken(false);
    setTokenFromUrl(null);
    // Stay on the login page and show normal login options
  };

  useEffect(() => {
    // Check for existing user session
    if (cookies?.userId) {
      navigate("/dashboard/overview");
      return;
    }

    // Check for token in URL
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get("token");

    console.log("URL params:", window.location.search);
    console.log("Extracted token:", urlToken);

    if (urlToken) {
      setTokenFromUrl(urlToken);
      setProcessingToken(true);
      // Remove token from URL for security
      // window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [cookies?.userId]);

  // If processing token, show the TokenBasedAuth component
  if (processingToken && tokenFromUrl) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Authenticating with token...</p>
        </div>
        <TokenBasedAuth
          token={tokenFromUrl}
          onAuthSuccess={handleTokenAuthSuccess}
          onAuthFailure={handleTokenAuthFailure}
        />
      </div>
    );
  }

  return (
    <>
      <Row className="align-items-center justify-content-center g-8 min-vh-100">
        {/* First Column (Left-Aligned) */}
        <Col
          lg={6}
          md={6}
          className="d-flex flex-column justify-content-center align-items-center bg-light py-5 mx-0"
        >
          <h1
            className="mb-0 text-center"
            style={{
              fontSize: "2rem",
              color: "#000000",
            }}
          >
            <span style={{ color: "#224B99" }}>Skill up</span> & be relevant
            with changing time
          </h1>
          <img
            style={{
              width: "100%",
              marginBottom: "30px",
            }}
            src={loginpage}
            className="mb-4 signuplogo2"
            alt="Signup Logo"
          />
        </Col>
        <Col lg={6} md={6} className="py-8 mx-0 py-xl-0">
          <Card className="shadow-lg">
            <Card.Body className="p-4">
              {showSsoLogin ? (
                <>
                  <SignIn />
                </>
              ) : (
                <>
                  <CustomLogin />
                  <div className="mt-5">
                    <div
                      onClick={handleShowSsoLogin}
                      className="cursor-pointer  text-center text-primary fs-4 fw-bold d-flex justify-content-center align-items-center"
                    >
                      <div>
                        <img
                          src={microsoftIcon}
                          alt="microsoft icon"
                          width={20}
                          height={20}
                        />
                      </div>
                      <div className="mx-2"> LOGIN WITH MICROSOFT</div>
                    </div>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AuthHome;
